import { LocationType } from '@guryou/core';
export * from './Action';
export * from './ActionStatus';
export * from './Notification';
export * from './NotificationType';
export * from './StateStatus';
export * from './actionHelpers';
export * from './basicReducer';
export * from './buildActionType';
export * from './countReducer';
export * from './stateChecks';
export const handleLocationInput = data => {
  const {
    latitude,
    longitude,
    locationType,
    locationNote,
    address,
    url
  } = data;
  const request = {};
  if (+locationType === LocationType.mapLocation) {
    request.latitude = +latitude;
    request.longitude = +longitude;
    request.address = address;
  } else if (+locationType === LocationType.plainNote || +locationType === LocationType.onlineLocation) {
    request.locationNote = locationNote;
    request.url = url;
  }
  return request;
};